import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import convertNumbThousand from "../../utils/convertNumbThousand";
import API_URL from "../../redux2";
import Locals from "../../utils/localFlights";
import {
  INTERNATIONAL_SYSTEM_FEE,
  LOCAL_SYSTEM_FEE,
  USER_ROLE_EMPLOYEE,
  USER_ROLE_SUPERAGENT,
  VOID_SC_AMOUNT,
} from "../../common/constants";
import { useSelector } from "react-redux";

const VoidPassengerModal = ({
  show,
  onHide,
  booking,
  setLoading,
  setError,
  voidType,
}) => {
  const { user } = useSelector((state) => state.auth);
  const passengers = booking?.passengers
    ?.map((passenger, index) => ({
      ...passenger,
      ticketNumber: booking?.flight?.ticketNumber?.[index],
    }))
    .filter((passenger) => passenger.status !== "voided");

  const basePrice = booking.passengers.reduce((acc, passenger) => {
    return passenger.status !== "voided" ? acc + passenger.price : acc;
  }, 0);

  const [base, setBase] = useState(0);
  const [charge, setCharge] = useState(passengers?.length);
  const [voidPassenger, setVoidPassenger] = useState([]);

  const navigate = useNavigate();

  const isSuper =
    [USER_ROLE_SUPERAGENT, USER_ROLE_EMPLOYEE].includes(user?.role) &&
    !booking?.company;

  const SC = isSuper ? 0 : VOID_SC_AMOUNT;
  const existingVoidSC =
    SC * (booking?.passengers?.length - passengers?.length);
  let service = booking?.serviceCharge / passengers?.length;

  const handleVoidPassenger = async (e) => {
    e.preventDefault();

    if (voidPassenger.length === 0) {
      toast.error("Please select at least one passenger to void");
      return;
    }

    if (passengers?.length !== voidPassenger?.length) {
      if (basePrice + booking?.serviceCharge > booking?.totalPrice) {
        toast.error("Airline error, Please contact sterling support.");
        return;
      }
    }

    let isLocal =
      Locals.includes(booking?.flight?.destination) &&
      Locals.includes(booking?.flight?.origin);

    const data = {
      ProviderLocatorCode: booking?.flight?.providerPnr,
      documentNumbers: [],
      bookingId: booking?._id,
      company: booking?.company?._id,
      charge,
      existingVoidSC,
      service,
      type: passengers?.length === voidPassenger?.length ? "full" : "partial",
      // totalPrice:
      //   booking?.flight?.price + service * charge - base + existingVoidSC,
      // toWallet:
      //   booking?.totalPrice -
      //   (booking?.flight?.price + service * charge - base) -
      //   existingVoidSC,
      // basePrice: booking?.flight?.price - base,
      // serviceCharge: service * charge + existingVoidSC,
      passengerIds: voidPassenger.map((passenger) => passenger._id),
      voidSC: SC,
      systemFee: +(
        isLocal
          ? LOCAL_SYSTEM_FEE * (passengers.length - voidPassenger?.length)
          : service * charge * 0.2
      ).toFixed(2),
      // : booking?.company
      // ? service * charge * 0.2
      // : INTERNATIONAL_SYSTEM_FEE *
      //   (passengers.length - voidPassenger?.length)
    };

    for (let i = 0; i < voidPassenger?.length; i++) {
      data.documentNumbers.push({
        DocumentNumber: voidPassenger?.[i]?.ticketNumber,
        DocumentType: "E-Ticket",
      });
    }

    onHide();
    setLoading(true);
    try {
      if (voidType === "manual") {
        await axios.post(API_URL + "flight/void-manual-ticket", data);

        toast.success("Ticket voided successfully");
        return;
      } else {
        const res = await axios.post(API_URL + "flight/void-ticket", data);

        if (
          res.data?.AirVoidDocumentRsp?.VoidResultInfo?.[0]?.FailureRemark
            ?._text ||
          res.data?.AirVoidDocumentRsp?.VoidResultInfo?.FailureRemark?._text
        ) {
          setError(
            res.data?.AirVoidDocumentRsp?.VoidResultInfo?.FailureRemark?._text
          );
          return;
        }
      }
      toast.success("Booking voided successfully");
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        navigate(0);
      }, 1000);
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-right"
    >
      <Modal.Body>
        <div className="mx-auto w-full max-w-lg">
          <h5 className="mb-6 text-2xl font-semibold text-center text-gray-800">
            Select the Ticket to Void{" "}
            {voidType === "manual"
              ? "(This only returns the ticket price to the agent)"
              : ""}
          </h5>
          <form action="">
            {/* Select All Button */}
            <div className="flex justify-between items-center mb-4 rounded-md">
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="select-all"
                  className="w-5 h-5 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                  checked={charge === 0}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    const newBase = isChecked ? booking?.flight?.price : 0;
                    const newCharge = isChecked ? 0 : passengers?.length;

                    setBase(newBase);
                    setCharge(newCharge);

                    passengers?.forEach((passenger, index) => {
                      const passengerCheckboxId = `void-passenger-${index}`;
                      const passengerCheckbox =
                        document.getElementById(passengerCheckboxId);

                      if (passengerCheckbox) {
                        passengerCheckbox.checked = isChecked;
                      } else {
                        console.warn(
                          `Element with id "${passengerCheckboxId}" not found.`
                        );
                      }
                    });

                    setVoidPassenger(
                      isChecked
                        ? passengers?.map((passenger) => ({
                            ...passenger,
                            ticketNumber: passenger?.ticketNumber || "",
                          }))
                        : []
                    );
                  }}
                />
                <label
                  htmlFor="select-all"
                  className="block my-2 ml-3 text-base font-medium text-gray-700 cursor-pointer"
                >
                  Select All
                </label>
              </div>
            </div>
            {passengers?.map((passenger, index) => (
              <div
                className="flex justify-between items-center p-4 mb-4 bg-gray-100 rounded-md transition duration-150 ease-in-out hover:bg-gray-200"
                key={index}
              >
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    name="void-passenger"
                    id={`void-passenger-${index}`}
                    className="w-5 h-5 text-indigo-600 transition duration-150 ease-in-out form-checkbox"
                    value={passenger.id}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setBase(base + passenger?.price);
                        setCharge(charge - 1);
                        setVoidPassenger([
                          ...voidPassenger,
                          {
                            ...passenger,
                          },
                        ]);
                      } else {
                        setBase(base - passenger?.price);
                        setCharge(charge + 1);
                        setVoidPassenger(
                          voidPassenger.filter(
                            (data) => data._id !== passenger._id
                          )
                        );
                      }
                    }}
                  />
                  <label
                    htmlFor={`void-passenger-${index}`}
                    className="block mt-2 ml-3 text-base font-medium text-gray-700 cursor-pointer"
                  >
                    {passenger.firstName} {passenger.lastName}
                  </label>
                </div>
                <div className="text-gray-500">{passenger.ticketNumber}</div>
              </div>
            ))}
          </form>
          {/* show total price */}
          <div className="grid flex-wrap grid-cols-2 gap-x-5 mt-6 text-lg">
            <div className="flex flex-row gap-2 mr-10">
              <div className="text-gray-600">Total Price:</div>
              <div className="font-semibold text-gray-800">
                {convertNumbThousand(
                  booking?.flight?.price + service * charge - base
                )}
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="text-gray-600">System Fair :</div>
              <div className="font-semibold text-gray-800">
                {convertNumbThousand(booking?.flight?.price - base)}
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="text-gray-600">Sterling S.C :</div>
              <div className="font-semibold text-gray-800">
                {convertNumbThousand(service * charge)}
              </div>
            </div>
            {!isSuper && (
              <div className="flex flex-row gap-2">
                <div className="text-gray-600">Void S.C :</div>
                <div className="font-semibold text-gray-800">
                  {SC * voidPassenger.length}
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex gap-3 justify-end mt-6">
          <button
            type="button"
            className="px-4 py-2 mr-2 text-gray-700 bg-gray-200 rounded-md transition duration-150 ease-in-out hover:bg-gray-300"
            onClick={onHide}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-white bg-rose-600 rounded-md transition duration-150 ease-in-out hover:bg-rose-700"
            onClick={handleVoidPassenger}
          >
            Void Booking
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default VoidPassengerModal;
